module.exports = __webpack_public_path__ + "img/電気回路_1_8_5.0a4af63f.png";